import ServiceInfoIcons from '@/icons/ServiceInfoIcons'
import ServiceMonitoringIcons from '@/icons/ServiceMonitoringIcons'
import ServiceNotiIcons from '@/icons/ServiceNotiIcons'
import ServiceReceiptIcons from '@/icons/ServiceReceiptIcons'
import ServiceSettingIcons from '@/icons/ServiceSettingIcons'
import SLAIcons from '@/icons/SLAIcons'
// import BlockIcons from '@/icons/BlockIcons'
import SettingIcons from '@/icons/SettingIcons'
import { DollarSign } from 'lucide-react'
import { ServiceStatus } from '@/modules/Service/types'
import { WarningIcons } from 'vnetwork-ui'
import TabComponents from './TabComponents'
import ServiceTemplates from './Templates'
import { TFunction } from 'i18next'

// Templates whose config is not editable via the generic config tab.
const SERVICE_TEMPLATE_NO_CONFIG_EDIT = [
    'SSL.SSL',
    'Domain.VNNIC',
    'Domain.TLDs',
    'Device.Liquidation',
]

const SERVICE_TEMPLATE_STATEMENTS = [
    'SwiftFederation.CDN',
    'SwiftFederation.Recording',
    'SwiftFederation.Transcoding',
    'SwiftFederation.Recording',
    'SwiftFederation.StorageLFD',
    'SwiftFederation.StorageOSS',
    'SwiftFederation.Transmuxing',
    'Mlytics.Vnis',
    'Cloud.VCloud',
]

const SERVICE_TEMPLATE_MONITORING = [
    'SwiftFederation.CDN',
    'SwiftFederation.Recording',
    'SwiftFederation.Transcoding',
    'SwiftFederation.Recording',
    'SwiftFederation.StorageLFD',
    'SwiftFederation.StorageOSS',
    'SwiftFederation.Transmuxing',
    'Mlytics.Vnis',
    // 'Cloud.VCloud',
]

const SERVICE_TEMPLATE_ALERTS = [
    'SwiftFederation.CDN',
    'SwiftFederation.Recording',
    'SwiftFederation.Transcoding',
    'SwiftFederation.Recording',
    'SwiftFederation.StorageLFD',
    'SwiftFederation.StorageOSS',
    'SwiftFederation.Transmuxing',
    'Mlytics.Vnis',
]

export const useServiceTabs = (
    t: TFunction,
    serviceTemplate?: keyof typeof ServiceTemplates,
    serviceStatus?: ServiceStatus,
    isPoc: boolean = false
) => {
    if (!serviceTemplate || !serviceStatus) return []

    const tabs = [
        {
            label: t('basic-information'),
            value: '',
            startIcon: <ServiceInfoIcons />,
            component: <TabComponents.Information />,
        },
        {
            label: t('service-prices-vat'),
            value: 'service-prices-vat',
            startIcon: <DollarSign className="w-4 h-4" />,
            component: <TabComponents.Prices />,
        },
        {
            label: t('edit-service-config'),
            value: 'service-config',
            startIcon: <SettingIcons />,
            component: <TabComponents.Config />,
            hidden:
                SERVICE_TEMPLATE_NO_CONFIG_EDIT.includes(
                    serviceTemplate as string
                ) ||
                serviceStatus === ServiceStatus.PendingTerminated ||
                serviceStatus === ServiceStatus.Rejected,
        },
        {
            label: t('service-setting'),
            value: 'service-setting',
            startIcon: <ServiceSettingIcons />,
            component: <TabComponents.Setting />,
            hidden: true,
        },
        {
            label: t('service-statement'),
            value: 'service-statement',
            startIcon: <SettingIcons />,
            component: <TabComponents.Statement />,
            hidden:
                !serviceTemplate ||
                isPoc ||
                !SERVICE_TEMPLATE_STATEMENTS.includes(
                    serviceTemplate as keyof typeof ServiceTemplates
                ),
        },
        {
            label: t('service-alert'),
            value: 'service-alert',
            startIcon: <WarningIcons />,
            component: <TabComponents.Alerts />,
            hidden:
                !serviceTemplate ||
                !SERVICE_TEMPLATE_ALERTS.includes(
                    serviceTemplate as keyof typeof ServiceTemplates
                ),
        },
        {
            label: t('service-notification'),
            value: 'service-notification',
            startIcon: <ServiceNotiIcons />,
            component: <TabComponents.Notification />,
        },
        {
            label: t('service-receipt'),
            value: 'service-receipt',
            startIcon: <ServiceReceiptIcons />,
            component: <TabComponents.Receipt />,
        },
        {
            label: t('service-monitoring'),
            value: 'service-monitoring',
            startIcon: <ServiceMonitoringIcons />,
            component: <TabComponents.Monitoring />,
            hidden:
                !serviceTemplate ||
                !SERVICE_TEMPLATE_MONITORING.includes(
                    serviceTemplate as keyof typeof ServiceTemplates
                ) ||
                (serviceStatus !== ServiceStatus.Active &&
                    serviceStatus !== ServiceStatus.Trialing),
        },
        {
            label: t('service-sla'),
            value: 'sla',
            startIcon: <SLAIcons />,
            component: <TabComponents.SLA />,
        },
    ]

    return tabs.filter((tab) => {
        return !tab.hidden
    })
}
